import React from "react";

export default function MentionsLegales() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-950 via-black to-slate-950 text-slate-100 py-20 px-6">
      <div className="max-w-3xl mx-auto bg-slate-900/60 rounded-2xl shadow-xl border border-slate-800/50 p-8">
        <h1 className="text-4xl font-extrabold text-white mb-8 text-center">📜 Mentions légales</h1>
        <div className="space-y-8 text-base md:text-lg">
          <section>
            <h2 className="text-xl font-bold text-emerald-400 mb-2">1. Éditeur du site</h2>
            <p>Le présent site est édité par :</p>
            <ul className="list-disc ml-6">
              <li>Ambroise Cainne – Auto-entrepreneur</li>
              <li>Adresse : 7 boulevard de Maupou, France</li>
              <li>E-mail : <a href="mailto:contact@hiperyon.com" className="text-emerald-400 hover:underline">contact@hiperyon.com</a></li>
            </ul>
            <p className="mt-2">Responsable de la publication : Ambroise Cainne</p>
            <p>Numéro SIRET : <span className="italic">(à compléter lorsque disponible)</span></p>
          </section>
          <section>
            <h2 className="text-xl font-bold text-emerald-400 mb-2">2. Informations sur le site</h2>
            <ul className="list-disc ml-6">
              <li>Nom du site : Hiperyon</li>
              <li>URL : <a href="https://hiperyon.com" className="text-emerald-400 hover:underline">https://hiperyon.com</a></li>
              <li>Objet du site : plateforme SaaS permettant aux utilisateurs de s’inscrire et d’accéder à des services en ligne.</li>
            </ul>
          </section>
          <section>
            <h2 className="text-xl font-bold text-emerald-400 mb-2">3. Hébergement</h2>
            <ul className="list-disc ml-6">
              <li>Vercel Inc.</li>
              <li>Adresse : 340 S Lemon Ave #4133, Walnut, CA 91789, États-Unis</li>
              <li>Site web : <a href="https://vercel.com" className="text-emerald-400 hover:underline">https://vercel.com</a></li>
            </ul>
          </section>
          <section>
            <h2 className="text-xl font-bold text-emerald-400 mb-2">4. Données personnelles et cookies (RGPD)</h2>
            <p>Le site Hiperyon collecte des données personnelles dans le cadre de l’inscription des utilisateurs et de l’analyse du trafic.<br />Les données collectées peuvent inclure : nom, e-mail et pseudo.</p>
            <p className="mt-2 font-semibold">Finalité de la collecte :</p>
            <ul className="list-disc ml-6">
              <li>Gestion des inscriptions et des comptes utilisateurs</li>
              <li>Marketing (informations liées au service)</li>
              <li>Analyse statistique de l’audience</li>
            </ul>
            <p className="mt-2 font-semibold">Outils utilisés :</p>
            <ul className="list-disc ml-6">
              <li>Google Analytics pour l’analyse de l’audience</li>
              <li>Formulaire d’inscription interne</li>
            </ul>
            <p className="mt-2">Les données collectées ne sont en aucun cas vendues ou transmises à des tiers non autorisés.</p>
            <p>Conformément au Règlement Général sur la Protection des Données (RGPD), vous disposez d’un droit d’accès, de rectification et de suppression de vos données.<br />Pour toute demande, vous pouvez nous contacter à l’adresse : <a href="mailto:contact@hyperiome.com" className="text-emerald-400 hover:underline">contact@hyperiome.com</a></p>
            <p className="mt-2">L’utilisation du site implique l’acceptation de l’utilisation de cookies nécessaires à son bon fonctionnement et à des fins analytiques.</p>
          </section>
          <section>
            <h2 className="text-xl font-bold text-emerald-400 mb-2">5. Propriété intellectuelle</h2>
            <p>L’ensemble des éléments présents sur le site Hiperyon (textes, images, graphismes, logo, code, structure, base de données, etc.) est la propriété exclusive de Ambroise Cainne, sauf mention contraire.</p>
            <p>Toute reproduction, représentation, modification, publication, transmission ou dénaturation, totale ou partielle du site ou de son contenu, par quelque procédé que ce soit, et sur quelque support que ce soit, est interdite sans autorisation écrite préalable.</p>
          </section>
          <section>
            <h2 className="text-xl font-bold text-emerald-400 mb-2">6. Conditions d’abonnement</h2>
            <p>Le site Hiperyon propose plusieurs offres d’abonnement :</p>
            <ul className="list-disc ml-6">
              <li>Gratuit : fonctionnalités de base</li>
              <li>Pro : fonctionnalités avancées mensuelles</li>
              <li>Pro Max : fonctionnalités complètes mensuelles</li>
              <li>Pro Max Annuel : fonctionnalités complètes annuelles à tarif préférentiel</li>
            </ul>
            <p>Les tarifs et conditions détaillés sont accessibles sur la page d’abonnement du site.</p>
          </section>
          <section>
            <h2 className="text-xl font-bold text-emerald-400 mb-2">7. Limitation de responsabilité</h2>
            <p>L’éditeur ne saurait être tenu responsable des dommages directs ou indirects pouvant résulter de l’utilisation du site ou de l’impossibilité d’y accéder.<br />L’utilisateur est seul responsable de la compatibilité de son matériel et de sa connexion internet.</p>
          </section>
          <section>
            <h2 className="text-xl font-bold text-emerald-400 mb-2">8. Droit applicable</h2>
            <p>Les présentes mentions légales sont régies par le droit français.<br />En cas de litige, les juridictions françaises seront seules compétentes.</p>
          </section>
        </div>
      </div>
    </div>
  );
}
